import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as models from '../../models'

export type Config<TTypeParams extends ec.models.TypeParams.Constraint> =
  Required.Semi<Config.SemiOptional<TTypeParams>, 'append' | 'prepend'>
export namespace Config {
  export function from<TTypeParams extends ec.models.TypeParams.Constraint>({
    append = [],
    createCustom,
    getItem,
    prepend = [],
  }: Config.SemiOptional<TTypeParams>): Config<TTypeParams> {
    return {
      append,
      createCustom,
      getItem,
      prepend,
    }
  }

  export interface SemiOptional<
    TTypeParams extends ec.models.TypeParams.Constraint,
  > {
    /**
     * Used to enable creating/editing custom single-select options
     */
    readonly createCustom?: {
      readonly fromLabel: (label: string) => TTypeParams['createEntity']
    }
    /**
     * How to obtain configuration for each item in the select.
     */
    readonly getItem: (entity: TTypeParams['entity']) => models.Item
    /**
     * An array of items that will be added to the beginning of the dropdown
     * list. These items appear first in the dropdown, before any dynamically
     * loaded. Use this to highlight options that should be
     * immediately visible to users, such as special items.
     */
    readonly prepend?: readonly models.Item[]
    /**
     * An array of items that will be added at the end of the dropdown list.
     * These items appear after dynamically loaded items.
     */
    readonly append?: readonly models.Item[]
  }
}
